import { motion } from "framer-motion";

const TEAM_IMG =
  "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?auto=format&fit=crop&q=85&w=1600";

const values = [
  { t: "Cercanía", d: "Escuchamos primero. Conocemos tu negocio antes de proponer soluciones." },
  { t: "Rigor", d: "Aplicamos la normativa con criterio técnico y actualización constante." },
  { t: "Transparencia", d: "Sin sorpresas: honorarios claros y comunicación fluida." },
  { t: "Compromiso", d: "Tus plazos son nuestros plazos. Anticipamos y prevenimos." },
];

const zones = ["Garraf", "Baix Camp", "Alt Penedés", "Baix Penedés", "Tarragonès"];

export default function SobreNosotros() {
  return (
    <div>
      <section className="relative overflow-hidden grain">
        <div className="absolute inset-0">
          <img src={TEAM_IMG} alt="Equipo" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/70 via-[#0a0a0a]/85 to-[#0a0a0a]" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-32">
          <div className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] mb-6">Sobre nosotros</div>
          <h1 className="font-serif text-5xl md:text-7xl text-white leading-[1.02] max-w-4xl">
            Un despacho <em className="gold-text not-italic">humano</em>,
            <br />
            con visión técnica.
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="sticky top-28">
            <div className="text-xs uppercase tracking-[0.28em] text-[#D4AF37] mb-4">Nuestra historia</div>
            <h2 className="font-serif text-3xl md:text-4xl text-white leading-tight">
              25 años acompañando a empresarios y autónomos.
            </h2>
          </div>
        </div>
        <div className="md:col-span-7 space-y-6 text-lg text-zinc-300 leading-relaxed">
          <p>
            Nacimos con una convicción: la asesoría de calidad no es un servicio genérico, sino una
            relación cercana en la que entendemos a fondo tu situación para brindarte el apoyo exacto
            que necesitas.
          </p>
          <p>
            Desde entonces hemos acompañado a cientos de empresas y autónomos por toda Cataluña, desde
            la comarca del Garraf hasta el Baix Camp, en cada etapa: la constitución, la gestión
            diaria, la expansión y también los momentos difíciles como una inspección administrativa.
          </p>
          <p>
            Nos define un equipo multidisciplinar en las cuatro áreas —fiscal, contable, laboral y
            mercantil— trabajando de forma coordinada para que nunca tengas que repetir tu historia.
          </p>
        </div>
      </section>

      <section className="bg-[#08080a] border-y border-white/5 py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-xs uppercase tracking-[0.28em] text-[#D4AF37] mb-4">Nuestros valores</div>
          <h2 className="font-serif text-3xl md:text-5xl text-white mb-14 max-w-2xl">
            Lo que nos guía cada día.
          </h2>
          <div className="grid md:grid-cols-4 gap-6">
            {values.map((v, i) => (
              <motion.div
                key={v.t}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="border-l border-[#D4AF37]/40 pl-5"
              >
                <div className="font-serif text-2xl text-white mb-3">{v.t}</div>
                <p className="text-zinc-400 leading-relaxed">{v.d}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24">
        <div className="text-xs uppercase tracking-[0.28em] text-[#D4AF37] mb-4">
          ¿Dónde trabajamos?
        </div>
        <h2 className="font-serif text-3xl md:text-5xl text-white mb-10 max-w-3xl">
          Nos movemos por gran parte del <em className="gold-text not-italic">territorio catalán</em>.
        </h2>
        <div className="flex flex-wrap gap-3">
          {zones.map((z) => (
            <span
              key={z}
              className="px-5 py-2.5 rounded-full border border-white/10 text-zinc-300 hover:border-[#D4AF37]/50 hover:text-[#D4AF37] transition-colors"
            >
              {z}
            </span>
          ))}
        </div>
      </section>
    </div>
  );
}
